export const subcategories = [
    { id: 'base_hauling', name: 'Base Hauling' },
    { id: 'fuel_surcharge', name: 'Fuel Surcharge' },
    { id: 'stop_charge', name: 'Stop Charge' },
    { id: 'production_payment', name: 'Production Payment' },
    { id: 'premium', name: 'Premium' },
    { id: 'deduction', name: 'Deduction' },
    { id: 'advertising', name: 'Advertising' },
    { id: 'assignment', name: 'Assignment' },
    { id: 'product', name: 'Product' },
];

export const ruleTypes = [
    { id: 'basic', name: 'Basic' },
    { id: 'tiered', name: 'Tiered' },
];

export const basisOptions = [
    { id: 'fixed', name: 'Fixed' },
    { id: 'cwt', name: 'CWT' },
    { id: 'lbs', name: 'Lbs' },
    { id: 'per_pickup', name: 'Per Pickup (tank)' },
    { id: 'per_load', name: 'Per Load' },
    { id: 'per_day_with_pickup', name: 'Per Day With Pickup' },
    { id: 'every_other_day_stop_charge', name: 'Every Other Day Stop Charge' },
    { id: 'over_every_other_day_stop_charge', name: 'Over Every Other Day Stop Charge' },
    { id: 'percent_gross_pay', name: 'Percent of Gross Pay' },
    { id: 'percent_net_pay', name: 'Percent of Net Pay' },
    { id: 'percent_base_hauling', name: 'Percent of Base Hauling' },
    { id: 'percent_fuel_surcharge', name: 'Percent of Fuel Surcharge' },
    { id: 'percent_stop_charge', name: 'Percent of Stop Charge' },
    { id: 'percent_total_hauling', name: 'Percent of Total Hauling' },
    { id: 'percent_cwt_milk_value', name: 'Percent of CWT Milk Value' },
    { id: 'percent_component_milk_value', name: 'Percent of Component Milk Value' },
];

// cwt, lbs, per_pickup, per_load, per_day_with_pickup, every_other_day_stop_charge, over_every_other_day_stop_charge basis selected
export const milkTypeOptions = [
    { id: 'all_milk', name: 'All Milk' },
    { id: 'a', name: 'Grade A' },
    { id: 'degrade', name: 'Degrade' },
    { id: 'conventional', name: 'Conventional' },
    { id: 'kosher', name: 'Kosher' },
    { id: 'organic', name: 'Organic' },
];
// If cwt or lbs is selected, also show component select
export const componentOptions = [
    { id: 'all_milk', name: 'All Milk' },
    { id: 'butterfat', name: 'Butterfat' },
    { id: 'protein', name: 'Protein' },
    { id: 'other_solids', name: 'Other Solids' },
    { id: 'somatic_cell_count', name: 'SCC' },
    { id: 'previous_month_weekly_average', name: 'Previous Month Weekly Avg. Pounds' },
    { id: 'skim_milk', name: 'Skim Milk' },
];

// percent basis
const milkTypeOptionsForPercent = [
    { id: 'base_hauling', name: 'Base Hauling' },
    { id: 'fuel_surcharge', name: 'Fuel Surcharge' },
    { id: 'stop_charge', name: 'Stop Charge' },
    { id: 'total_hauling', name: 'Total Hauling' },
    { id: 'gross_pay', name: 'Gross Pay' },
    { id: 'net_pay', name: 'Net Pay' },
    { id: 'cwt_milk_value', name: 'CWT Milk Value' },
];

export const paymentAmountOptions = [
    { id: 'amount_paid', name: 'Amount Paid' },
    { id: 'monetary_value', name: 'Total Value' },
    { id: 'none', name: 'None' },
];

export const rateCategoryOptions = [
    { id: 'gross_pay', name: 'Above Gross Pay' },
    { id: 'deduction', name: 'Below Gross Pay' },
];

export const whenCondition = [
    { name: 'All', id: 'all' },
    { name: 'Any', id: 'any' },
];

export const ConditionOptions = Object.freeze({
    LESS_THAN_OR_EQUAL_TO: 'LESS_THAN_OR_EQUAL_TO',
    LESS_THAN: 'LESS_THAN',
    EQUAL_TO: 'EQUAL_TO',
    GREATER_THAN_OR_EQUAL_TO: 'GREATER_THAN_OR_EQUAL_TO',
    GREATER_THAN: 'GREATER_THAN',
    BETWEEN: 'BETWEEN',
});

export const conditionOptions = [
    { name: 'Less than or equal to (≤)', id: 'LESS_THAN_OR_EQUAL_TO' },
    { name: 'Less than (<)', id: 'LESS_THAN' },
    { name: 'Equal to (=)', id: 'EQUAL_TO' },
    { name: 'Greater than or equal to (≥)', id: 'GREATER_THAN_OR_EQUAL_TO' },
    { name: 'Greater than (>)', id: 'GREATER_THAN' },
    { name: 'Between (>= and <=)', id: 'BETWEEN' },
];

export const operatorMap = {
    lte: conditionOptions[0].id,
    lt: conditionOptions[1].id,
    eq: conditionOptions[2].id,
    gte: conditionOptions[3].id,
    gt: conditionOptions[4].id,
    between: conditionOptions[5].id,
};

export const criteriaOptions = [
    { name: 'Total Pounds', id: 'pounds_shipped', boolean: false },
    { name: 'Grade A Milk Pounds', id: 'grade_a_milk_pounds', boolean: false },
    { name: 'Degrade Milk Pounds', id: 'degrade_milk_pounds', boolean: false },
    { name: 'Advance Milk Pounds (1-15)', id: 'advance_milk_pounds', boolean: false },
    { name: 'Settlement Milk Pounds (16-EOM)', id: 'settlement_milk_pounds', boolean: false },
    { name: 'Advance Protein Pounds (1-15)', id: 'advance_protein_pounds', boolean: false },
    { name: 'Settlement Protein Pounds (16-EOM)', id: 'settlement_protein_pounds', boolean: false },
    { name: 'Total Protein Pounds', id: 'total_protein_pounds', boolean: false },
    { name: 'Advance Protein Weighted Average (1-15)', id: 'advance_protein_weighted_average', boolean: false },
    { name: 'Settlement Protein Weighted Average (16-EOM)', id: 'settlement_protein_weighted_average', boolean: false },
    { name: 'Total Protein Weighted Average', id: 'total_protein_weighted_average', boolean: false },
    { name: 'Advance Fat Pounds (1-15)', id: 'advance_fat_pounds', boolean: false },
    { name: 'Settlement Fat Pounds (16-EOM)', id: 'settlement_fat_pounds', boolean: false },
    { name: 'Total Fat Pounds', id: 'total_fat_pounds', boolean: false },
    { name: 'Advance Fat Weighted Average (1-15)', id: 'advance_fat_weighted_average', boolean: false },
    { name: 'Settlement Fat Weighted Average (16-EOM)', id: 'settlement_fat_weighted_average', boolean: false },
    { name: 'Total Fat Weighted Average', id: 'total_fat_weighted_average', boolean: false },
    { name: 'Advance Other Solids Pounds (1-15)', id: 'advance_other_solids_pounds', boolean: false },
    { name: 'Settlement Other Solids Pounds (16-EOM)', id: 'settlement_other_solids_pounds', boolean: false },
    { name: 'Total Other Solids Pounds', id: 'total_other_solids_pounds', boolean: false },
    { name: 'Advance Other Solids Weighted Average (1-15)', id: 'advance_other_solids_weighted_average', boolean: false },
    { name: 'Settlement Other Solids Weighted Average (16-EOM)', id: 'settlement_other_solids_weighted_average', boolean: false },
    { name: 'Total Other Solids Weighted Average', id: 'total_other_solids_weighted_average', boolean: false },
    // SCC Weighted
    { name: 'SCC Weighted Average', id: 'SCC', boolean: false },
    { name: 'Advance SCC Weighted Average (1-15)', id: 'advance_SCC_weighted_average', boolean: false },
    { name: 'Settlement SCC Weighted Average (16-EOM)', id: 'settlement_SCC_weighted_average', boolean: false },
    { name: 'SCC Weighted Average Excluding Highest Per Tank', id: 'SCC_excluding_highest_per_tank', boolean: false },
    { name: 'Advance SCC Weighted Average (1-15) Excluding Highest Per Tank', id: 'advance_SCC_weighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'Settlement SCC Weighted Average (16-EOM) Excluding Highest Per Tank', id: 'settlement_SCC_weighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'SCC Weighted Average Excluding Highest Result', id: 'SCC_weighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Advance SCC Weighted Average (1-15) Excluding Highest Result', id: 'advance_SCC_weighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Settlement SCC Weighted Average (16-EOM) Excluding Highest Result', id: 'settlement_SCC_weighted_average_excluding_highest_per_producer', boolean: false },
    // SCC Unweighted
    { name: 'SCC Unweighted Average', id: 'unweighted_scc_avg', boolean: false },
    { name: 'Advance SCC Unweighted Average (1-15)', id: 'advance_SCC_unweighted_average', boolean: false },
    { name: 'Settlement SCC Unweighted Average (16-EOM)', id: 'settlement_SCC_unweighted_average', boolean: false },
    { name: 'SCC Unweighted Average Excluding Highest Per Tank', id: 'SCC_unweighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'Advance SCC Unweighted Average (1-15) Excluding Highest Per Tank', id: 'advance_SCC_unweighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'Settlement SCC Unweighted Average (16-EOM) Excluding Highest Per Tank', id: 'settlement_SCC_unweighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'SCC Unweighted Average Excluding Highest Result', id: 'SCC_unweighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Advance SCC Unweighted Average (1-15) Excluding Highest Result', id: 'advance_SCC_unweighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Settlement SCC Unweighted Average (16-EOM) Excluding Highest Result', id: 'settlement_SCC_unweighted_average_excluding_highest_per_producer', boolean: false },
    // SPC Weighted
    { name: 'SPC Weighted Average', id: 'SPC', boolean: false },
    { name: 'Advance SPC Weighted Average (1-15)', id: 'advance_SPC_weighted_average', boolean: false },
    { name: 'Settlement SPC Weighted Average (16-EOM)', id: 'settlement_SPC_weighted_average', boolean: false },
    { name: 'SPC Weighted Average Excluding Highest Per Tank', id: 'SPC_excluding_highest_per_tank', boolean: false },
    { name: 'Advance SPC Weighted Average (1-15) Excluding Highest Per Tank', id: 'advance_SPC_weighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'Settlement SPC Weighted Average (16-EOM) Excluding Highest Per Tank', id: 'settlement_SPC_weighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'SPC Weighted Average Excluding Highest Result', id: 'SPC_weighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Advance SPC Weighted Average (1-15) Excluding Highest Result', id: 'advance_SPC_weighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Settlement SPC Weighted Average (16-EOM) Excluding Highest Result', id: 'settlement_SPC_weighted_average_excluding_highest_per_producer', boolean: false },
    // SPC Unweighted
    { name: 'SPC Unweighted Average', id: 'unweighted_spc_avg', boolean: false },
    { name: 'Advance SPC Unweighted Average (1-15)', id: 'advance_SPC_unweighted_average', boolean: false },
    { name: 'Settlement SPC Unweighted Average (16-EOM)', id: 'settlement_SPC_unweighted_average', boolean: false },
    { name: 'SPC Unweighted Average Excluding Highest Per Tank', id: 'SPC_unweighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'Advance SPC Unweighted Average (1-15) Excluding Highest Per Tank', id: 'advance_SPC_unweighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'Settlement SPC Unweighted Average (16-EOM) Excluding Highest Per Tank', id: 'settlement_SPC_unweighted_average_excluding_highest_per_tank', boolean: false },
    { name: 'SPC Unweighted Average Excluding Highest Result', id: 'SPC_unweighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Advance SPC Unweighted Average (1-15) Excluding Highest Result', id: 'advance_SPC_unweighted_average_excluding_highest_per_producer', boolean: false },
    { name: 'Settlement SPC Unweighted Average (16-EOM) Excluding Highest Result', id: 'settlement_SPC_unweighted_average_excluding_highest_per_producer', boolean: false },
    // Cryoscope
    { name: 'Advance Lowest Cryoscope Result (1-15)', id: 'advance_lowest_cryoscope_result', boolean: false },
    { name: 'Settlement Lowest Cryoscope Result (16-EOM)', id: 'settlement_lowest_cryoscope_result', boolean: false },
    { name: 'PIC Average', id: 'PIC', boolean: false },
    { name: 'RBC Average', id: 'RBC', boolean: false },
    { name: 'Previous Quarter IgG Weighted Average', id: 'previous_quarter_igg_weighted_average', boolean: false },
    { name: 'Abnormal Freeze Point', id: 'had_abnormal_freezing_point', boolean: true },
    { name: 'Had Regulatory Sample Violation', id: 'had_regulatory_sample_violation', boolean: true },
    { name: 'High or Rejected Load', id: 'had_high_or_rejected_load', boolean: true },
    { name: 'Lowest Cryoscope Result', id: 'lowest_cryoscope_result', boolean: false },
    { name: 'Positive Drug Residue', id: 'had_positive_drug_residue', boolean: true },
    { name: 'RBC Penalty Waived', id: 'RBC_penalty_waived', boolean: true },
    { name: 'Total SCC Violations', id: 'total_scc_violations', boolean: false },
    { name: 'Total SPC Violations', id: 'total_spc_violations', boolean: false },
    { name: '#3 or #4 Sediment', id: 'had_three_or_four_sediment', boolean: true },
    { name: 'Hauling Credit Override', id: 'hauling_credit_overridden', boolean: true },
    { name: 'Barn Score', id: 'barn_score_override', boolean: false },
    { name: 'Rolling Annual Barn Score', id: 'annual_average_barn_score', boolean: false },
    { name: 'Average Temperature', id: 'average_temperature', boolean: false },
    { name: 'Average Freeze Point', id: 'average_freeze_point', boolean: false },
    { name: 'Stop Count', id: 'stop_count_override', boolean: false },
    { name: 'Advance Stop Count', id: 'advance_stop_count', boolean: false },
    { name: 'Settlement Stop Count', id: 'settlement_stop_count', boolean: false },
    { name: 'Load Count', id: 'load_count', boolean: false },
    { name: 'Advance Load Count', id: 'advance_load_count', boolean: false },
    { name: 'Settlement Load Count', id: 'settlement_load_count', boolean: false },
    { name: 'Is Organic', id: 'is_organic', boolean: true },
    { name: 'Number of SCC Geomean Avg Over 400 In Past Six Months', id: 'count_scc_geomean_over_400_past_six_months', boolean: false },
    { name: 'Three Month SCC Geomean', id: 'three_month_scc_geomean', boolean: false },
    { name: 'Number of Months Since Last SCC Geomean Penalty', id: 'number_of_months_since_last_scc_geomean_penalty', boolean: false },
    { name: 'Last SCC Geomean Penalty Amount', id: 'last_scc_geomean_penalty_amount', boolean: false },
    { name: 'Advance Active Days', id: 'advance_active_days', boolean: false },
    { name: 'Settlement Active Days', id: 'settlement_active_days', boolean: false },
    { name: 'Current Payment Rate', id: 'payment_rate', boolean: false },
    { name: 'Average Pounds Per Pickup', id: 'average_pounds_per_pickup', boolean: false },
];

export const mathCriteriaOptions = [
    { name: 'Total Milk Pounds', id: '#TotalMilkPounds' },
    { name: 'Grade A Milk Pounds', id: '#GradeAMilkPounds' },
    { name: 'Degrade Milk Pounds', id: '#DegradeMilkPounds' },
    { name: 'Advance Milk Pounds (1-15)', id: '#AdvanceMilkPounds' },
    { name: 'Settlement Milk Pounds (16-EOM)', id: '#SettlementMilkPounds' },
    { name: 'Advance Protein Pounds (1-15)', id: '#AdvanceProteinPounds' },
    { name: 'Settlement Protein Pounds (16-EOM)', id: '#SettlementProteinPounds' },
    { name: 'Total Protein Pounds', id: '#TotalProteinPounds' },
    { name: 'Advance Protein Weighted Average (1-15)', id: '#AdvanceProteinWeightedAverage' },
    { name: 'Settlement Protein Weighted Average (16-EOM)', id: '#SettlementProteinWeightedAverage' },
    { name: 'Total Protein Weighted Average', id: '#TotalProteinWeightedAverage' },
    { name: 'Advance Fat Pounds (1-15)', id: '#AdvanceFatPounds' },
    { name: 'Settlement Fat Pounds (16-EOM)', id: '#SettlementFatPounds' },
    { name: 'Total Fat Pounds', id: '#TotalFatPounds' },
    { name: 'Advance Fat Weighted Average (1-15)', id: '#AdvanceFatWeightedAverage' },
    { name: 'Settlement Fat Weighted Average (16-EOM)', id: '#SettlementFatWeightedAverage' },
    { name: 'Total Fat Weighted Average', id: '#TotalFatWeightedAverage' },
    { name: 'Advance Other Solids Pounds (1-15)', id: '#AdvanceOtherSolidsPounds' },
    { name: 'Settlement Other Solids Pounds (16-EOM)', id: '#SettlementOtherSolidsPounds' },
    { name: 'Total Other Solids Pounds', id: '#TotalOtherSolidsPounds' },
    { name: 'Advance Other Solids Weighted Average (1-15)', id: '#AdvanceOtherSolidsWeightedAverage' },
    { name: 'Settlement Other Solids Weighted Average (16-EOM)', id: '#SettlementOtherSolidsWeightedAverage' },
    { name: 'Total Other Solids Weighted Average', id: '#TotalOtherSolidsWeightedAverage' },
    // SCC Weighted Averages
    { name: 'SCC Weighted Average', id: '#SCCAverage' },
    { name: 'Advance SCC Weighted Average (1-15)', id: '#AdvanceSCCWeightedAverage' },
    { name: 'Settlement SCC Weighted Average (16-EOM)', id: '#SettlementSCCWeightedAverage' },
    { name: 'SCC Weighted Average Excluding Highest Per Tank', id: '#SCCAverageExcludingHighestPerTank' },
    { name: 'Advance SCC Weighted Average (1-15) Excluding Highest Per Tank', id: '#AdvanceSCCWeightedAverageExcludingHighestPerTank' },
    { name: 'Settlement SCC Weighted Average (16-EOM) Excluding Highest Per Tank', id: '#SettlementSCCWeightedAverageExcludingHighestPerTank' },
    { name: 'SCC Weighted Average Excluding Highest Result', id: '#SCCWeightedAverageExcludingHighestResult' },
    { name: 'Advance SCC Weighted Average (1-15) Excluding Highest Result', id: '#AdvanceSCCWeightedAverageExcludingHighestResult' },
    { name: 'Settlement SCC Weighted Average (16-EOM) Excluding Highest Result', id: '#SettlementSCCWeightedAverageExcludingHighestResult' },
    // SCC Unweighted Averages
    { name: 'SCC Unweighted Average', id: '#SCCUnweightedAverage' },
    { name: 'Advance SCC Unweighted Average (1-15)', id: '#AdvanceSCCUNweightedAverage' },
    { name: 'Settlement SCC Unweighted Average (16-EOM)', id: '#SettlementSCCUnweightedAverage' },
    { name: 'SCC Unweighted Average Excluding Highest Per Tank', id: '#SCCUnweightedAverageExcludingHighestPerTank' },
    { name: 'Advance SCC Unweighted Average (1-15) Excluding Highest Per Tank', id: '#AdvanceSCCUnweightedAverageExcludingHighestPerTank' },
    { name: 'Settlement SCC Unweighted Average (16-EOM) Excluding Highest Per Tank', id: '#SettlementSCCUnweightedAverageExcludingHighestPerTank' },
    { name: 'SCC Unweighted Average Excluding Highest Result', id: '#SCCUnweightedAverageExcludingHighestResult' },
    { name: 'Advance SCC Unweighted Average (1-15) Excluding Highest Result', id: '#AdvanceSCCUnweightedAverageExcludingHighestResult' },
    { name: 'Settlement SCC Unweighted Average (16-EOM) Excluding Highest Result', id: '#SettlementSCCUnweightedAverageExcludingHighestResult' },
    // SPC Weighted Averages
    { name: 'SPC Weighted Average', id: '#SPCAverage' },
    { name: 'Advance SPC Weighted Average (1-15)', id: '#AdvanceSPCAverage' },
    { name: 'Settlement SPC Weighted Average (16-EOM)', id: '#SettlementSPCAverage' },
    { name: 'SPC Weighted Average Excluding Highest Per Tank', id: '#SPCAverageExcludingHighestPerTank' },
    { name: 'Advance SPC Weighted Average (1-15) Excluding Highest Per Tank', id: '#AdvanceSPCAverageExcludingHighestPerTank' },
    { name: 'Settlement SPC Weighted Average (16-EOM) Excluding Highest Per Tank', id: '#SettlementSPCAverageExcludingHighestPerTank' },
    { name: 'SPC Weighted Average Excluding Highest Result', id: '#SPCWeightedAverageExcludingHighestResult' },
    { name: 'Advance SPC Weighted Average (1-15) Excluding Highest Result', id: '#AdvanceSPCWeightedAverageExcludingHighestResult' },
    { name: 'Settlement SPC Weighted Average (16-EOM) Excluding Highest Result', id: '#SettlementSPCWeightedAverageExcludingHighestResult' },
    // SPC Unweighted Averages
    { name: 'SPC Unweighted Average', id: '#SPCUnweightedAverage' },
    { name: 'Advance SPC Unweighted Average (1-15)', id: '#AdvanceSPCUnweightedAverage' },
    { name: 'Settlement SPC Unweighted Average (16-EOM)', id: '#SettlementSPCUnweightedAverage' },
    { name: 'SPC Unweighted Average Excluding Highest Per Tank', id: '#SPCUnweightedAverageExcludingHighestPerTank' },
    { name: 'Advance SPC Unweighted Average (1-15) Excluding Highest Per Tank', id: '#AdvanceSPCUnweightedAverageExcludingHighestPerTank' },
    { name: 'Settlement SPC Unweighted Average (16-EOM) Excluding Highest Per Tank', id: '#SettlementSPCUnweightedAverageExcludingHighestPerTank' },
    { name: 'SPC Unweighted Average Excluding Highest Result', id: '#SPCUnweightedAverageExcludingHighestResult' },
    { name: 'Advance SPC Unweighted Average (1-15) Excluding Highest Result', id: '#AdvanceSPCUnweightedAverageExcludingHighestResult' },
    { name: 'Settlement SPC Unweighted Average (16-EOM) Excluding Highest Result', id: '#SettlementSPCUnweightedAverageExcludingHighestResult' },

    { name: 'PIC Average', id: '#PICAverage' },
    { name: 'RBC Average', id: '#RBCAverage' },
    { name: 'Previous Quarter IgG Weighted Average', id: '#PreviousQuarterIgGWeightedAverage' },
    { name: 'Advance Lowest Cryoscope Result (1-15)', id: '#AdvanceLowestCryoscopeResult' },
    { name: 'Settlement Lowest Cryoscope Result (16-EOM)', id: '#SettlementLowestCryoscopeResult' },
    { name: 'Lowest Cryoscope Result', id: '#LowestCryoscopeResult' },
    { name: 'Total SCC Violations', id: '#TotalSCCViolations' },
    { name: 'Total SPC Violations', id: '#TotalSPCViolations' },
    { name: 'Average Temperature', id: '#AverageTemperature' },
    { name: 'Average Freeze Point', id: '#AverageFreezePoint' },
    { name: 'Barn Score', id: '#BarnScore' },
    { name: 'Rolling Average Barn Score', id: '#RollingAverageBarnScore' },
    { name: 'Stop Count', id: '#StopCount' },
    { name: 'Advance Stop Count', id: '#AdvanceStopCount' },
    { name: 'Settlement Stop Count', id: '#SettlementStopCount' },
    { name: 'Load Count', id: '#LoadCount' },
    { name: 'Advance Load Count', id: '#AdvanceLoadCount' },
    { name: 'Settlement Load Count', id: '#SettlementLoadCount' },
    { name: 'Number of SCC Geomean Avg Over 400 In Past Six Months', id: '#NumberOfSCCGeomeanAvgOver400Past6Months' },
    { name: 'Three Month SCC Geomean', id: '#ThreeMonthSCCGeomean' },
    { name: 'Number of Months Since Last SCC Geomean Penalty', id: '#NumberMonthsSinceLastSCCGeomeanPenalty' },
    { name: 'Last SCC Geomean Penalty Amount', id: '#LastSCCGeomeanPenaltyAmount' },
    { name: 'Advance Active Days', id: '#AdvanceActiveDays' },
    { name: 'Settlement Active Days', id: '#SettlementActiveDays' },
    { name: 'Current Payment Rate', id: '#CurrentPaymentRate' },
    { name: 'Average Pounds Per Pickup', id: '#AveragePoundsPerPickup' },
];

export const criteriaOptionsMap = {
    '#TotalMilkPounds': 'pounds_shipped',
    '#GradeAMilkPounds': 'grade_a_milk_pounds',
    '#DegradeMilkPounds': 'degrade_milk_pounds',
    // SCC Weighted Averages
    '#SCCAverage': 'SCC',
    '#AdvanceSCCWeightedAverage': 'advance_SCC_weighted_average',
    '#SettlementSCCWeightedAverage': 'settlement_SCC_weighted_average',
    '#SCCAverageExcludingHighestPerTank': 'SCC_excluding_highest_per_tank',
    '#AdvanceSCCWeightedAverageExcludingHighestPerTank': 'advance_SCC_weighted_average_excluding_highest_per_tank',
    '#SettlementSCCWeightedAverageExcludingHighestPerTank': 'settlement_SCC_weighted_average_excluding_highest_per_tank',
    '#SCCWeightedAverageExcludingHighestResult': 'SCC_weighted_average_excluding_highest_per_producer',
    '#AdvanceSCCWeightedAverageExcludingHighestResult': 'advance_SCC_weighted_average_excluding_highest_per_producer',
    '#SettlementSCCWeightedAverageExcludingHighestResult': 'settlement_SCC_weighted_average_excluding_highest_per_producer',
    // SCC Unweighted Averages
    '#SCCUnweightedAverage': 'unweighted_scc_avg',
    '#AdvanceSCCUnweightedAverage': 'advance_SCC_unweighted_average',
    '#SettlementSCCUnweightedAverage': 'settlement_SCC_unweighted_average',
    '#SCCUnweightedAverageExcludingHighestPerTank': 'SCC_unweighted_average_excluding_highest_per_tank',
    '#AdvanceSCCUnweightedAverageExcludingHighestPerTank': 'advance_SCC_unweighted_average_excluding_highest_per_tank',
    '#SettlementSCCUnweightedAverageExcludingHighestPerTank': 'settlement_SCC_unweighted_average_excluding_highest_per_tank',
    '#SCCUnweightedAverageExcludingHighestResult': 'SCC_unweighted_average_excluding_highest_per_producer',
    '#AdvanceSCCUnweightedAverageExcludingHighestResult': 'advance_SCC_unweighted_average_excluding_highest_per_producer',
    '#SettlementSCCUnweightedAverageExcludingHighestResult': 'settlement_SCC_unweighted_average_excluding_highest_per_producer',
    // SPC Weighted Averages
    '#SPCAverage': 'SPC',
    '#AdvanceSPCAverage': 'advance_SPC_weighted_average',
    '#SettlementSPCAverage': 'settlement_SPC_weighted_average',
    '#SPCAverageExcludingHighestPerTank': 'SPC_excluding_highest_per_tank',
    '#AdvanceSPCAverageExcludingHighestPerTank': 'advance_SPC_weighted_average_excluding_highest_per_tank',
    '#SettlementSPCAverageExcludingHighestPerTank': 'settlement_SPC_weighted_average_excluding_highest_per_tank',
    '#SPCWeightedAverageExcludingHighestResult': 'SPC_weighted_average_excluding_highest_per_producer',
    '#AdvanceSPCWeightedAverageExcludingHighestResult': 'advance_SPC_weighted_average_excluding_highest_per_producer',
    '#SettlementSPCWeightedAverageExcludingHighestResult': 'settlement_SPC_weighted_average_excluding_highest_per_producer',
    // SPC Unweighted Averages
    '#SPCUnweightedAverage': 'unweighted_spc_avg',
    '#AdvanceSPCUnweightedAverage': 'advance_SPC_unweighted_average',
    '#SettlementSPCUnweightedAverage': 'settlement_SPC_unweighted_average',
    '#SPCUnweightedAverageExcludingHighestPerTank': 'SPC_unweighted_average_excluding_highest_per_tank',
    '#AdvanceSPCUnweightedAverageExcludingHighestPerTank': 'advance_SPC_unweighted_average_excluding_highest_per_tank',
    '#SettlementSPCUnweightedAverageExcludingHighestPerTank': 'settlement_SPC_unweighted_average_excluding_highest_per_tank',
    '#SPCUnweightedAverageExcludingHighestResult': 'SPC_unweighted_average_excluding_highest_per_producer',
    '#AdvanceSPCUnweightedAverageExcludingHighestResult': 'advance_SPC_unweighted_average_excluding_highest_per_producer',
    '#SettlementSPCUnweightedAverageExcludingHighestResult': 'settlement_SPC_unweighted_average_excluding_highest_per_producer',

    '#PICAverage': 'PIC',
    '#RBCAverage': 'RBC',
    '#PreviousQuarterIgGWeightedAverage': 'previous_quarter_igg_weighted_average',
    '#LowestCryoscopeResult': 'lowest_cryoscope_result',
    '#AdvanceLowestCryoscopeResult': 'advance_lowest_cryoscope_result',
    '#SettlementLowestCryoscopeResult': 'settlement_lowest_cryoscope_result',
    '#TotalSCCViolations': 'total_scc_violations',
    '#TotalSPCViolations': 'total_spc_violations',
    '#AverageTemperature': 'average_temperature',
    '#AverageFreezePoint': 'average_freeze_point',
    '#BarnScore': 'barn_score_override',
    '#RollingAverageBarnScore': 'annual_average_barn_score',
    '#StopCount': 'stop_count_override',
    '#AdvanceStopCount': 'advance_stop_count',
    '#SettlementStopCount': 'settlement_stop_count',
    '#LoadCount': 'load_count',
    '#AdvanceLoadCount': 'advance_load_count',
    '#SettlementLoadCount': 'settlement_load_count',
    '#CurrentPaymentRate': 'payment_rate',
    '#AdvanceMilkPounds': 'advance_milk_pounds',
    '#SettlementMilkPounds': 'settlement_milk_pounds',
    '#AdvanceProteinPounds': 'advance_protein_pounds',
    '#SettlementProteinPounds': 'settlement_protein_pounds',
    '#TotalProteinPounds': 'total_protein_pounds',
    '#AdvanceProteinWeightedAverage': 'advance_protein_weighted_average',
    '#SettlementProteinWeightedAverage': 'settlement_protein_weighted_average',
    '#TotalProteinWeightedAverage': 'total_protein_weighted_average',
    '#AdvanceFatPounds': 'advance_fat_pounds',
    '#SettlementFatPounds': 'settlement_fat_pounds',
    '#TotalFatPounds': 'total_fat_pounds',
    '#AdvanceFatWeightedAverage': 'advance_fat_weighted_average',
    '#SettlementFatWeightedAverage': 'settlement_fat_weighted_average',
    '#TotalFatWeightedAverage': 'total_fat_weighted_average',
    '#AdvanceOtherSolidsPounds': 'advance_other_solids_pounds',
    '#SettlementOtherSolidsPounds': 'settlement_other_solids_pounds',
    '#TotalOtherSolidsPounds': 'total_other_solids_pounds',
    '#AdvanceOtherSolidsWeightedAverage': 'advance_other_solids_weighted_average',
    '#SettlementOtherSolidsWeightedAverage': 'settlement_other_solids_weighted_average',
    '#TotalOtherSolidsWeightedAverage': 'total_other_solids_weighted_average',
    '#AdvanceActiveDays': 'advance_active_days',
    '#SettlementActiveDays': 'settlement_active_days',
    '#NumberOfSCCGeomeanAvgOver400Past6Months': 'count_scc_geomean_over_400_past_six_months',
    '#ThreeMonthSCCGeomean': 'three_month_scc_geomean',
    '#NumberMonthsSinceLastSCCGeomeanPenalty': 'number_of_months_since_last_scc_geomean_penalty',
    '#LastSCCGeomeanPenaltyAmount': 'last_scc_geomean_penalty_amount',
    '#AveragePoundsPerPickup': 'average_pounds_per_pickup',
};

export const daysInMonth = Array.from({ length: 31 }, (_, i) => ({ name: (i + 1).toString(), id: i + 1 }));

export const lineItemGroups = [
    { name: 'SCC Geomean Penalty', id: 'scc_geomean_penalty' },
    { name: 'Butterfat', id: 'butterfat' },
    { name: 'Protein', id: 'protein' },
    { name: 'Other Solids', id: 'other_solids' },
    { name: 'PPD', id: 'ppd' },
    { name: 'Location Adjustment', id: 'location_adjustment' },
    { name: 'Skim Milk', id: 'skim_milk' },
    { name: 'Organic Rate', id: 'organic_rate' },
    { name: 'SCC', id: 'scc' },
];

export const mathOperators = [
    { id: '@ADD(, )', name: 'Add' },
    { id: '@SUBTRACT(, )', name: 'Subtract' },
    { id: '@MULTIPLY(, )', name: 'Multiply' },
    { id: '@DIVIDE(, )', name: 'Divide' },
    { id: '@POW(, )', name: 'Power' },
    { id: '@MIN(, )', name: 'Minimum' },
    { id: '@MAX(, )', name: 'Maximum' },
];

export const externalPricesOptions = [
    // CME Prices
    { id: '#ButterAvgMonthlyCME', name: 'CME Butter Average Monthly Price' },
    { id: '#Cheese40BlockAvgMonthlyCME', name: 'CME Cheese 40lb Block Average Monthly Price' },
    { id: '#CheeseBarrelsAvgMonthlyCME', name: 'CME Cheese Barrels Average Monthly Price' },
    { id: '#DryWheyExtraAvgMonthlyCME', name: 'CME Dry Whey Extra Average Monthly Price' },
    { id: '#NonFatDryMilkAvgMonthlyCME', name: 'CME Non Fat Dry Milk Average Monthly Price' },
    // Raw Milk Prices
    { id: '#UniformMilkPrice', name: 'Uniform Milk Price' },
    { id: '#UniformButterfatPrice', name: 'Uniform Butterfat Price' },
    { id: '#UniformSkimPrice', name: 'Uniform Skim Price' },
    { id: '#UniformPpdPrice', name: 'Uniform PPD Price' },
    { id: '#Class1ButterfatPrice', name: 'Class 1 Butterfat Price' },
    { id: '#Class1SkimPrice', name: 'Class 1 Skim Price' },
    { id: '#AdvancedSkimMilkClass2Price', name: 'Advanced Skim Milk Class 2 Price' },
    { id: '#Class2SnfPrice', name: 'Class 2 SNF Price' },
    { id: '#Class2Price', name: 'Class 2 Price' },
    { id: '#Class2ButterfatPrice', name: 'Class 2 Butterfat Price' },
    { id: '#Class3Price', name: 'Class 3 Price' },
    { id: '#Class3SkimMilkPrice', name: 'Class 3 Skim Milk Price' },
    { id: '#Class4Price', name: 'Class 4 Price' },
    { id: '#Class4SkimMilkPrice', name: 'Class 4 Skim Milk Price' },
    { id: '#ButterfatPrice', name: 'Butterfat Price' },
    { id: '#NonfatSolidsPrice', name: 'Nonfat Solids Price' },
    { id: '#ProteinPrice', name: 'Protein Price' },
    { id: '#OtherSolidsPrice', name: 'Other Solids Price' },
    { id: '#SomaticCellAdjustmentRatePrice', name: 'Somatic Cell Adjustment Rate Price' },
    // Location-Based Prices
    { id: '#BasePriceByFipsCode', name: 'Base Price by FIPS Code' },
    { id: '#BasePriceByFmmo', name: 'Base Price by FMMO' },
    // DMN Averaged Prices
    { id: '#LactoseAverageDMN', name: 'DMN Lactose Average' },
    { id: '#NDMCentralWestAverageDMN', name: 'DMN NDM Central/West Average' },
];

export const externalPricesOptionsMap = {
    // CME Prices
    '#ButterAvgMonthlyCME': 'butter_avg_monthly_cme',
    '#Cheese40BlockAvgMonthlyCME': 'cheese_40_pound_block_avg_monthly_cme',
    '#CheeseBarrelsAvgMonthlyCME': 'cheese_barrels_avg_monthly_cme',
    '#DryWheyExtraAvgMonthlyCME': 'dry_whey_extra_avg_monthly_cme',
    '#NonFatDryMilkAvgMonthlyCME': 'non_fat_dry_milk_avg_monthly_cme',
    // Raw Milk Prices
    '#UniformMilkPrice': 'uniform_milk_price',
    '#UniformButterfatPrice': 'uniform_butterfat_price',
    '#UniformSkimPrice': 'uniform_skim_price',
    '#UniformPpdPrice': 'uniform_ppd_price',
    '#Class1ButterfatPrice': 'class_1_butterfat_price',
    '#Class1SkimPrice': 'class_1_skim_price',
    '#AdvancedSkimMilkClass2Price': 'advanced_skim_milk_class_2_price',
    '#Class2SnfPrice': 'class_2_snf_price',
    '#Class2Price': 'class_2_price',
    '#Class2ButterfatPrice': 'class_2_butterfat_price',
    '#Class3Price': 'class_3_price',
    '#Class3SkimMilkPrice': 'class_3_skim_milk_price',
    '#Class4Price': 'class_4_price',
    '#Class4SkimMilkPrice': 'class_4_skim_milk_price',
    '#ButterfatPrice': 'butterfat_price',
    '#NonfatSolidsPrice': 'nonfat_solids_price',
    '#ProteinPrice': 'protein_price',
    '#OtherSolidsPrice': 'other_solids_price',
    '#SomaticCellAdjustmentRatePrice': 'somatic_cell_adjustment_rate_price',
    // Location-Based Prices
    '#BasePriceByFipsCode': 'base_price_by_fips_code',
    '#BasePriceByFmmo': 'base_price_by_fmmo',
    // DMN Averaged Prices
    '#LactoseAverageDMN': 'dmn_lactose_average',
    '#NDMCentralWestAverageDMN': 'dmn_ndm_central_west_mostly_average',
};

export const mathOperatorToExpressionMap = {
    '@MULTIPLY': 'mul',
    '@DIVIDE': 'div',
    '@ADD': 'sum',
    '@SUBTRACT': 'sub',
    '@POW': 'pow',
    '@MIN': 'min',
    '@MAX': 'max',
};

export const getMilkTypeOptionsForBasis = (value) => {
    if (!value) return [];
    switch (value) {
        case 'cwt':
        case 'lbs':
        case 'per_load':
        case 'per_pickup':
        case 'per_day_with_pickup':
        case 'every_other_day_stop_charge':
        case 'over_every_other_day_stop_charge':
            return milkTypeOptions;
        case 'percent':
            return milkTypeOptionsForPercent;
        default:
            return [];
    }
};

export const getSelectOptionFromValue = (options, value) => {
    const option = options.find((op) => op.id === value);
    return option?.id ?? null;
};

export const getRolesNameByRuleType = (ruleType) => {
    switch (ruleType) {
        case 'producerHauler':
            return ['Hauler', 'Producer'];
        case 'producerVendor':
            return ['Vendor', 'Producer'];
        case 'haulerVendor':
            return ['Vendor', 'Hauler'];
        default:
            return ['Payee', 'Payer'];
    }
};
